import React from "react";

const DashboardCard = ({ title, value, gradient }) => {
    return (
        <div className="col-lg-4 col-md-12 col-6 mb-6">
            <div className={`card h-100 ${gradient}`}>
                <div className="card-body">
                    <p className="mb-1 text-white">{title}</p>
                    <h4 className="card-title mb-3 text-white">{value}</h4>
                </div>
            </div>
        </div>
    );
};

export default DashboardCard;
